/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {isCurrentTheme} from '@ion/dls/src/theme/useThemeContext';
import SensorSummaryAccordion, {
  SensorSummaryAccordionProps
} from '@ion/features/src/smarterTrailer/SensorSummaryAccordion';
import {AssetDetailsSection, useRegisteredAccordion} from './assetDetailsAccordionStore';

/**
 * Renders the Asset Details Drawer's Smarter Trailer (sensor summary)
 * accordion, registered with the drawer's shared accordion store so the
 * drawer header's expand/collapse-all control can drive it - current theme
 * only, once its data has loaded; the legacy accordion stays uncontrolled.
 *
 * ```typescript
 *
 *   import {SmarterTrailerAccordion} from '@/routes/tracking/SmarterTrailerAccordion';
 *   ...
 *
 *   <SmarterTrailerAccordion smarterTrailer={smarterTrailer}
 *     onViewTireSensorReport={onViewTireSensorReport}
 *     loading={loading} />
 *
 * ```
 *
 * @param   props The `SensorSummaryAccordion` props.
 * @returns       The Smarter Trailer accordion.
 */
export const SmarterTrailerAccordion = (props: SensorSummaryAccordionProps) => {
  const {expanded, onExpand} = useRegisteredAccordion(
    AssetDetailsSection.smarterTrailer,
    true,
    isCurrentTheme() && !props.loading
  );

  return (
    <SensorSummaryAccordion {...props}
      expanded={isCurrentTheme() ? expanded : undefined}
      onExpand={onExpand} />
  );
};

export default SmarterTrailerAccordion;
